<div class="view-heading">
    <h2>ПОЧЕТНА СТРАНА</h2>
</div>
<div class="home-text">
    <span [appTranslate]="'HOME_TEXT'"></span>
</div>
<br>
 <div class="dashboard-boxes">
    <div class="row">
        <div class="col-md-4">
            <div class="border-box baranja">
                <div class="box ">
                    <h1>Барања</h1>
                    <p>Број на барања</p>
                    <span>10</span>
                </div>
            </div>

        </div>

        <div class="col-md-4">
            <div class="border-box baranja">
                <div class="box ">
                    <h1>Барања</h1>
                    <p>Број на одобрени барања</p>
                    <span>5</span>
                </div>
            </div>

        </div>

        <div class="col-md-4">
            <div class="border-box baranja">
                <div class="box ">
                    <h1>Износ</h1>
                    <p>Вкупен износ од барања</p>
                    <span>5500</span>
                </div>
            </div>

        </div>
    </div>
</div>
<div class="section-title">
    <h2>Листа на одбиени барања</h2>
</div> 